import {withStyles} from '@material-ui/core/styles'
import React from 'react'
import {TopToolbar, CreateButton, Datagrid, DateField, NumberField, List, TextField,} from 'react-admin'

const styles = theme => ({
  title: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  hiddenOnSmallScreens: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }
})
const Actions = ({basePath,}) => (
  <TopToolbar>
    <CreateButton basePath={basePath}/>
  </TopToolbar>
)

export default withStyles(styles)(({classes, ...props}) => {
  return (
    <List {...props}
          actions={<Actions/>}
          bulkActionButtons={false}>
      <Datagrid rowClick={'edit'}>
        <TextField source="id" sortable={false}/>
        <TextField source="site" sortable={false}/>
        <TextField source="title" sortable={false}/>
        <NumberField source="order" sortable={false}/>
        <DateField source="createdAt" locales='ko' showTime sortable={false}/>
      </Datagrid>
    </List>
  )
})

